module.exports = __webpack_public_path__ + "static/media/pet.01f2611c.svg";